import script from "./SidebarNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarNav.vue?vue&type=script&setup=true&lang=ts"

import "./SidebarNav.vue?vue&type=style&index=0&id=2773b5b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2773b5b7"]])

export default __exports__